var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoscCertificate = function SvgCoscCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.001 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M16.495 0A16.495 16.495 0 1 0 32.99 16.495 16.495 16.495 0 0 0 16.495 0m7.834 18.579h-5.57v5.588h-4.69v-5.588H8.5v-4.672h5.57v-5.57h4.69v5.57h5.57Z",
    "data-name": "Path 4580"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10154",
    transform: "translate(-691 -626.335)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#ebebeb",
    "data-name": "Ellipse 760",
    transform: "translate(691 626.335)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4629",
    transform: "translate(736.438 671.771)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.282,
    cy: 9.282,
    r: 9.282,
    fill: "#ffc62d",
    "data-name": "Ellipse 686"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.729 3.276h13.1v13.1h-13.1Z",
    "data-name": "Path 4503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.103 8.19h-2.184V4.914H7.643V8.19H5.459l3.822 3.824ZM8.735 9.282V6.006h1.092v3.276h.639l-1.185 1.185-1.185-1.185Zm-3.276 3.822h7.644v1.092H5.459Z",
    "data-name": "Path 4504"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e2240",
    strokeWidth: 0.5,
    d: "M730.835 660.84h-5.575v5.588h-4.69v-5.588H715v-4.672h5.57v-5.57h4.69v5.57h5.57Z",
    "data-name": "Path 4550"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3912"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3910"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0e2240",
    strokeWidth: 0.5,
    clipPath: "url(#a)",
    "data-name": "Group 3909",
    transform: "translate(706.505 642.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.459 17.268c-2.354 1.671-7.349-4.869-7.349-9.739-.108-6.63 5.858-8.769 12.991-1.941 3 3.162 3.9 6.81 2.983 7.457-.323.234-1.132.036-1.222.036a4.62 4.62 0 0 0-3.5.036c-.88.234-1.851.773-2.731-.036",
    "data-name": "Path 4551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.405 17.843c-2.48 1.689-7.3-4.905-7.3-9.523-.108-6.63 5.732-8.517 12.488-1.977 3.055 3.18 3.791 6.792 2.911 7.385a1.88 1.88 0 0 1-1.258-.018 4.5 4.5 0 0 0-3.36.018c-.862.234-1.779.665-2.516-.054",
    "data-name": "Path 4552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.351 18.418C13.746 20.125 9.11 13.477 9.11 9.11c-.108-6.63 5.606-8.265 12-2.03 3.091 3.2 3.683 6.774 2.821 7.331a1.76 1.76 0 0 1-1.276-.054c-.862-.413-1.617-.413-3.216 0-.827.252-1.707.557-2.318-.072",
    "data-name": "Path 4553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.279 19.011c-2.713 1.743-7.169-4.977-7.169-9.074-.108-6.63 5.48-8.014 11.5-2.084 3.162 3.2 3.594 6.756 2.767 7.259a1.63 1.63 0 0 1-1.276-.09c-.862-.413-1.527-.4-3.091-.018-.809.252-1.653.431-2.12-.108",
    "data-name": "Path 4554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.225 19.585c-2.839 1.761-7.1-5.013-7.1-8.84-.108-6.63 5.337-7.762 11.015-2.138 3.2 3.216 3.486 6.738 2.677 7.187a1.52 1.52 0 0 1-1.294-.144c-.862-.431-1.419-.359-2.947-.036-.773.252-1.581.323-1.923-.126",
    "data-name": "Path 4555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.153 20.178c-2.965 1.779-7.044-5.067-7.044-8.625-.108-6.63 5.211-7.511 10.512-2.174 3.252 3.234 3.378 6.72 2.605 7.133a1.41 1.41 0 0 1-1.309-.175c-.88-.449-1.33-.341-2.8-.054-.755.27-1.509.216-1.707-.144",
    "data-name": "Path 4556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.099 20.754c-3.091 1.8-6.99-5.1-6.99-8.409-.108-6.63 5.085-7.259 10.026-2.228 3.306 3.252 3.27 6.7 2.534 7.062a1.37 1.37 0 0 1-1.33-.216c-.88-.449-1.24-.323-2.659-.072-.719.27-1.437.09-1.509-.162",
    "data-name": "Path 4557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.471 16.225C13.8 13.871 20.34 8.876 25.21 8.876c6.612-.126 8.769 5.858 1.923 12.991-3.162 3-6.792 3.881-7.457 2.983-.234-.323-.036-1.132-.036-1.24a4.78 4.78 0 0 0-.018-3.5c-.234-.88-.791-1.851.018-2.731",
    "data-name": "Path 4558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.878 16.153c-1.689-2.48 4.905-7.3 9.523-7.3 6.63-.126 8.517 5.732 1.977 12.488-3.18 3.055-6.792 3.791-7.385 2.911a1.78 1.78 0 0 1 .018-1.258 4.55 4.55 0 0 0-.018-3.378c-.234-.845-.665-1.779.054-2.516",
    "data-name": "Path 4559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.302 16.1c-1.707-2.587 4.941-7.223 9.308-7.223 6.63-.126 8.265 5.606 2.03 12-3.2 3.109-6.774 3.7-7.331 2.839a1.76 1.76 0 0 1 .054-1.276c.413-.862.413-1.635 0-3.234-.234-.827-.557-1.707.072-2.318",
    "data-name": "Path 4560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.709 16.028c-1.725-2.713 5-7.169 9.074-7.169 6.63-.126 8.014 5.462 2.084 11.5-3.2 3.162-6.756 3.594-7.259 2.767a1.67 1.67 0 0 1 .09-1.294c.431-.862.4-1.527.018-3.091-.252-.809-.431-1.653.108-2.12",
    "data-name": "Path 4561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.135 15.974c-1.761-2.839 5.031-7.1 8.858-7.1 6.63-.126 7.762 5.337 2.12 11-3.216 3.216-6.738 3.486-7.187 2.7a1.49 1.49 0 0 1 .144-1.312c.431-.862.377-1.419.036-2.947-.252-.773-.323-1.581.126-1.923",
    "data-name": "Path 4562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.542 15.902c-1.779-2.965 5.067-7.044 8.643-7.044 6.63-.126 7.511 5.211 2.174 10.512-3.234 3.252-6.72 3.378-7.115 2.605a1.41 1.41 0 0 1 .18-1.312c.449-.88.341-1.33.054-2.8-.252-.755-.2-1.509.162-1.707",
    "data-name": "Path 4563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.967 15.849c-1.8-3.073 5.1-6.972 8.409-6.972 6.612-.126 7.259 5.085 2.228 10.008-3.252 3.306-6.7 3.288-7.062 2.534a1.37 1.37 0 0 1 .216-1.33c.467-.88.323-1.24.072-2.659-.27-.719-.09-1.437.18-1.509",
    "data-name": "Path 4564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.513 15.219c2.354-1.671 7.349 4.869 7.349 9.739.108 6.63-5.858 8.769-12.991 1.941-3-3.162-3.9-6.81-2.983-7.457.323-.234 1.132-.036 1.222-.036a4.7 4.7 0 0 0 3.5-.036c.88-.216 1.851-.773 2.731.036",
    "data-name": "Path 4565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.567 14.627c2.48-1.689 7.3 4.905 7.3 9.523.108 6.63-5.732 8.517-12.488 1.977-3.055-3.18-3.791-6.792-2.911-7.385a1.88 1.88 0 0 1 1.258.018 4.5 4.5 0 0 0 3.36-.018c.862-.234 1.779-.665 2.516.054",
    "data-name": "Path 4566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.626 14.051c2.605-1.707 7.241 4.941 7.241 9.308.108 6.63-5.606 8.265-12 2.03-3.108-3.2-3.684-6.774-2.839-7.331a1.86 1.86 0 0 1 1.276.054c.862.413 1.617.413 3.216 0 .827-.234 1.707-.557 2.318.072",
    "data-name": "Path 4567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.693 13.476c2.713-1.743 7.169 4.977 7.169 9.074.108 6.63-5.48 8.014-11.5 2.084-3.162-3.216-3.594-6.756-2.767-7.259a1.67 1.67 0 0 1 1.294.09c.863.431 1.527.4 3.091.018.809-.252 1.653-.431 2.12.108",
    "data-name": "Path 4568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.746 12.884c2.839-1.761 7.1 5.013 7.1 8.858.108 6.63-5.337 7.762-11.015 2.12-3.216-3.216-3.486-6.738-2.677-7.187a1.45 1.45 0 0 1 1.294.144c.862.431 1.437.377 2.947.036.773-.252 1.581-.323 1.923.126",
    "data-name": "Path 4569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.819 12.308c2.965-1.779 7.044 5.049 7.044 8.625.108 6.63-5.211 7.511-10.512 2.174-3.27-3.234-3.4-6.72-2.605-7.133a1.45 1.45 0 0 1 1.33.18c.88.449 1.33.341 2.8.054.755-.27 1.509-.2 1.707.144",
    "data-name": "Path 4570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.873 11.715c3.091-1.8 6.99 5.1 6.99 8.409.108 6.63-5.085 7.259-10.026 2.228-3.306-3.252-3.27-6.7-2.534-7.062a1.37 1.37 0 0 1 1.33.216c.88.449 1.24.323 2.659.072.719-.27 1.437-.09 1.509.18",
    "data-name": "Path 4571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.501 16.261c1.671 2.354-4.869 7.367-9.739 7.367-6.63.108-8.769-5.858-1.923-12.991 3.162-3 6.792-3.9 7.457-2.983.216.323.036 1.132.036 1.24a4.71 4.71 0 0 0 .036 3.5c.234.88.773 1.851-.036 2.731",
    "data-name": "Path 4572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.095 16.316c1.689 2.48-4.905 7.3-9.523 7.3-6.63.108-8.517-5.732-1.977-12.506 3.18-3.055 6.792-3.791 7.385-2.911a2 2 0 0 1-.018 1.258 4.5 4.5 0 0 0 .018 3.36c.234.862.665 1.779-.054 2.516",
    "data-name": "Path 4573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.669 16.388c1.725 2.587-4.941 7.241-9.308 7.241-6.63.108-8.265-5.606-2.03-12 3.18-3.109 6.774-3.7 7.313-2.839a1.76 1.76 0 0 1-.054 1.276c-.413.862-.413 1.617 0 3.216.252.827.557 1.707-.072 2.318",
    "data-name": "Path 4574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.262 16.441c1.725 2.713-5 7.169-9.092 7.169-6.63.108-8.014-5.48-2.066-11.518 3.2-3.162 6.756-3.594 7.259-2.767a1.63 1.63 0 0 1-.09 1.276c-.431.862-.4 1.527-.018 3.091.252.809.431 1.653-.108 2.12",
    "data-name": "Path 4575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.837 16.495c1.761 2.839-5.031 7.115-8.858 7.115-6.63.108-7.762-5.355-2.138-11.015 3.216-3.2 6.738-3.486 7.187-2.677a1.45 1.45 0 0 1-.144 1.294c-.431.862-.377 1.42-.036 2.947.252.773.323 1.581-.126 1.9",
    "data-name": "Path 4576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.43 16.567c1.779 2.965-5.067 7.044-8.625 7.044-6.63.108-7.511-5.211-2.174-10.512 3.234-3.27 6.72-3.378 7.115-2.605a1.41 1.41 0 0 1-.18 1.312c-.449.88-.341 1.33-.054 2.8.252.755.2 1.509-.144 1.707",
    "data-name": "Path 4577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.005 16.621c1.8 3.091-5.1 6.99-8.409 6.99-6.612.108-7.259-5.085-2.228-10.026 3.252-3.306 6.7-3.27 7.062-2.534a1.38 1.38 0 0 1-.234 1.348c-.467.88-.323 1.24-.072 2.659.27.719.09 1.437-.162 1.509",
    "data-name": "Path 4578"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e2240",
    strokeWidth: 0.5,
    d: "M730.835 660.839h-5.575v5.588h-4.69v-5.588H715v-4.672h5.57v-5.57h4.69v5.57h5.57Z",
    "data-name": "Group 3911"
  })))));
};
export { SvgCoscCertificate as ReactComponent };
export default "/_next/static/images/COSCCertificate.svg";